"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPresentation = exports.notificationTypes = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const polished_1 = require("polished");
const Layout_1 = require("../Layout");
exports.notificationTypes = {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success",
};
const NotificationPresentation = ({ type = "error", show = false, header = "", body = [], dismiss = void 0, }) => show ? (react_1.default.createElement(Wrapper, { type: type, onClick: dismiss, "data-testid": "notification" },
    react_1.default.createElement(Heading, { "data-testid": "label-header" }, header),
    body.length > 1 ? (react_1.default.createElement(Layout_1.Flex, { justify: "flex-start", col: true },
        react_1.default.createElement(Layout_1.FlexSpace, null),
        react_1.default.createElement(List, null, body.map((message, i) => (react_1.default.createElement("li", { key: i, "data-testid": "label-message-" + i }, message)))))) : body.length === 1 ? (react_1.default.createElement(Layout_1.Flex, { col: true },
        react_1.default.createElement(Layout_1.FlexSpace, null),
        react_1.default.createElement("div", { "data-testid": "label-message" }, body[0]))) : (""))) : null;
exports.NotificationPresentation = NotificationPresentation;
const Wrapper = styled_components_1.styled.div `
  position: fixed;
  top: 10px;
  right: 10px;
  background: ${(props) => props.theme.notification[props.type].bg};
  padding: 10px;
  color: ${(props) => props.theme.notification[props.type].fg};
  border-radius: ${(props) => props.theme.radius};
  border: 1px solid
    ${(props) => (0, polished_1.darken)(0.25, props.theme.notification[props.type].bg)};
  z-index: ${(props) => props.type === "error" ? 26 : props.type === "warning" ? 25 : 24};
  max-width: 350px;
`;
const List = styled_components_1.styled.ul `
  list-style-position: inside;
  padding-left: 0;
`;
const Heading = styled_components_1.styled.span `
  font-size: 1.1rem;
  font-weight: bold;
`;
//# sourceMappingURL=index.js.map